import api from '../../../config/axios'
import { API } from '../../../config/links'

export const AcceptanceCriteriaService = {
  updateAcceptanceCriteria: (id: string, criteria: Record<string, number>) =>
    api.put<{
      message: string;
      sensor_type_id: string;
      acceptance_criteria: Record<string, number>;
    }>(API.sensorTypes.acceptanceCriteria(id), criteria).then(res => res.data),
}
